import type { Translations } from './types'

export const it: Translations = {
  common: {
    stationUnknown: (nr) => `La stazione ${nr} non è ancora attiva.`,
    stationOffline: 'Nessuna connessione — riprova a scansionare più tardi.',
    toMap: 'Vai alla mappa',
    more: 'Altro',
    images: 'Immagini',
    retry: 'Riprova',
    back: 'Indietro',
    close: 'Chiudi',
    processing: 'Accesso in corso…',
  },

  landing: {
    hero: {
      title: 'Vivi la natura in\nRealt\u00E0 Aumentata',
      subtitle: () =>
        `Presto disponibile — registrati ora per essere tra i primi a sapere quando TSCHAPP sarà online.`,
      cta: 'Registrati ora',
      secondaryCta: 'Esplora',
    },
    intro: {
      heading: 'La gola\nprende vita',
      text: (count) =>
        `TSCHAPP porta in vita la Tscheppaschlucht a Ferlach. Con la Realt\u00E0 Aumentata puoi esplorare oltre ${count} specie animali e vegetali autoctone direttamente nel loro habitat naturale \u2014 con descrizioni dettagliate, articoli generati dall\u2019intelligenza artificiale e modelli 3D immersivi.`,
    },
    stats: {
      animals: 'Specie animali',
      plants: 'Specie vegetali',
      ar: 'Augmented Reality',
    },
    community: {
      heading: 'Unisciti alla comunit\u00E0',
      text: 'Con un account puoi mettere like alle specie, lasciare commenti e vivere la Tscheppaschlucht insieme ad altri appassionati di natura.',
      features: {
        like: {
          title: 'Metti like alle specie',
          description:
            'Segna le tue specie preferite e crea la tua collezione personale',
        },
        comment: {
          title: 'Commenta',
          description:
            'Condividi le tue conoscenze e connettiti con altri amanti della natura',
        },
        ar: {
          title: 'Vivi l\u2019AR',
          description:
            'Scopri le specie in Realt\u00E0 Aumentata direttamente nella gola',
        },
      },
      registerWithGoogle: 'Registrati con Google',
    },
    routes: {
      heading: 'Tre sentieri, un\u2019esperienza',
      text: 'Tutti i percorsi partono dal centro visitatori e attraversano la Tscheppaschlucht. Al bivio scegli la tua avventura.',
      stations: 'Stazioni',
      detailLink: 'Tutti i percorsi nel dettaglio',
    },
    stories: {
      heading: 'Storie dalla gola',
      text: 'Leggende, miti e le storie delle nostre mascotte \u2014 raccontate come audiolibro interattivo con illustrazioni generate dall\u2019IA.',
      narratorTschauko: 'Narrato da Tschauko',
      narratorTschauka: 'Narrato da Tschauka',
      scenes: 'Scene',
      allLink: 'Tutte le storie',
    },
    featured: {
      heading: 'Specie in evidenza',
      discoverLink: (count) => `Scopri tutte le ${count} specie`,
    },
  },

  browse: {
    badge: 'Flora & Fauna',
    heroTitle: 'Flora & Fauna',
    heroSubtitle: 'Scopri la fauna e la flora della Tscheppaschlucht',
    speciesCount: (count) => `${count} specie`,
    filterAll: 'Tutte',
    logout: 'Esci',
    login: 'Accedi',
    authBanner: 'Accedi per mettere like alle specie e lasciare commenti',
    close: 'Chiudi',
  },

  species: {
    loading: 'Caricamento oggetto...',
    analyzing: 'Analisi oggetto...',
    loading3d: 'Caricamento modello 3D...',
    preparing3d: 'Preparazione del modello 3D …',
    load3dFailed: 'Impossibile caricare il modello 3D.',
    arStartFailed: 'Impossibile avviare l’AR. Controlla l’autorizzazione WebXR del browser.',
    notFound: 'Oggetto non trovato',
    analysisFailed: 'Analisi fallita',
    noId: 'Nessun ID fornito',
    brandSubtitle: 'Vivi la natura in Realt\u00E0 Aumentata',
    featuresCount: (count) => `${count} caratteristiche`,
    share: 'Condividi',
    like: 'Mi piace',
    unlike: 'Non mi piace pi\u00F9',
    comments: 'Commenti',
    audioGuide: {
      label: 'Audioguida',
      subtitle: 'Ascolta la descrizione',
      noAudio: 'Nessun audio',
    },
    pause: 'Pausa',
    play: 'Riproduci',
    stopMusic: 'Ferma musica',
    view2d: 'Vista 2D',
    view3d: 'Vista 3D',
    commentsSection: {
      title: (count) => `Commenti (${count})`,
      empty: 'Ancora nessun commento. Sii il primo!',
      placeholder: 'Scrivi un commento...',
      delete: 'Elimina',
    },
    close: 'Chiudi',
    back: 'Indietro',
  },

  routes: {
    headerTitle: 'Sentieri escursionistici',
    heroTitle: 'Tre sentieri attraverso\nla gola',
    heroSubtitle:
      'Tutti i percorsi partono dal centro visitatori e attraversano l\u2019imponente Tscheppaschlucht. Al bivio decidi quale avventura ti attende.',
    stats: {
      kilometers: 'Chilometri',
      walkingTime: 'Tempo di percorrenza',
      stations: 'Stazioni',
    },
    sections: {
      routeCourse: 'Panoramica del percorso',
      elevationProfile: 'Profilo altimetrico',
      stations: 'Stazioni',
    },
    listToggle: 'Lista',
    loading3d: 'Caricamento vista 3D\u2026',
    elevationMin: 'min',
    elevationMax: 'max',
    back: 'Indietro',
    details: {
      listenDescription: 'Ascolta la descrizione',
      stopListening: 'Interrompi',
      listenRoute: 'Ascolta il percorso',
      guideLive: 'Dr. Tschauko dal vivo',
      nextStations: 'Prossime stazioni',
    },
  },

  stories: {
    languageFallback: 'Per ora questa leggenda è disponibile solo in tedesco.',
    badge: 'Leggende e storie',
    pageTitle: 'Leggende e storie',
    pageSubtitle:
      'I miti e le leggende della Tscheppaschlucht \u2014 narrati da Tschauko & Tschauka',
    narratorTschauko: '\uD83E\uDD89 Narrato da Tschauko',
    narratorTschauka: '\uD83D\uDC38 Narrato da Tschauka',
    chapterCounter: (current, total) => `Capitolo ${current} di ${total}`,
    chapterCount: (count) => `${count} capitoli`,
    startAudiobook: 'Avvia audiolibro',
    closeAudiobook: 'Chiudi audiolibro',
    previousChapter: 'Capitolo precedente',
    nextChapter: 'Capitolo successivo',
    done: 'Fatto',
    chapterN: (n) => `Capitolo ${n}`,
    toggleMode: 'Cambia modalit\u00E0',
    photoBackground: 'Sfondo fotografico',
    back: 'Indietro',
  },

  footer: {
    tagline:
      'Vivi la natura in Realt\u00E0 Aumentata. ',
    legal: {
      title: 'Note legali',
      imprint: 'Impressum',
      privacy: 'Informativa sulla privacy',
      terms: 'Condizioni d\u2019uso',
    },
    contact: 'Contatti',
    more: {
      title: 'Altro',
      floraFauna: 'Flora & Fauna',
    },
    sponsoredBy: 'Con il supporto di',
    copyright: (year) => `\u00A9 ${year} TSCHAPP \u00B7 Tutti i diritti riservati`,
  },

  units: {
    minuteShort: 'min',
    hourShort: 'h',
  },

  mapMarkers: {
    ticketOffice: 'Biglietteria',
    receptionHouse: 'Centro visitatori',
    goal: 'Arrivo',
  },

  legend: {
    title: 'Legenda',
    mainRoute: 'Percorso principale',
    sideTrail: 'Sentiero laterale',
    waterways: 'Corsi d’acqua',
    filterOnly: (kategorie: string) => `Mostra solo ${kategorie}`,
    filterClear: 'Rimuovi filtro — mostra tutto',
    byDistance: 'Distanza',
    byName: 'Nome',
  },

  nav: {
    home: 'Home',
    floraFauna: 'Flora & Fauna',
    routes: 'Hiking Trails',
    stories: 'Stories',
    login: 'Sign In',
    logout: 'Sign Out',
    myProfile: 'My Profile',
  },

  dialog: {
    register: {
      title: 'Registrati',
      description:
        'Unisciti alla comunit\u00E0 della Tscheppaschlucht. Scopri la natura in Realt\u00E0 Aumentata.',
      nameLabel: 'Nome',
      namePlaceholder: 'Il tuo nome',
      emailLabel: 'Email',
      emailPlaceholder: 'nome@esempio.com',
      passwordLabel: 'Password',
      passwordPlaceholder: 'Min. 8 caratteri',
      submit: 'Crea account',
      google: 'Registrati con Google',
      alreadyRegistered: 'Gi\u00E0 registrato?',
      loginLink: 'Accedi',
      or: 'oppure',
      emailSent: 'Ti abbiamo inviato una conferma. Puoi continuare ora!',
      emailHint: 'Ti avviseremo quando TSCHAPP sar\u00E0 online.',
    },
    login: {
      title: 'Accedi',
      description:
        'Metti like alle specie, lascia commenti e vivi la Tscheppaschlucht insieme ad altri appassionati di natura.',
      emailLabel: 'Email',
      emailPlaceholder: 'nome@esempio.com',
      passwordLabel: 'Password',
      passwordPlaceholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022',
      submit: 'Accedi',
      google: 'Accedi con Google',
      noAccount: 'Non hai ancora un account?',
      registerLink: 'Registrati',
    },
    survey: {
      title: 'Sondaggio rapido',
      description: 'Aiutaci a migliorare TSCHAPP \u2014 4 brevi domande.',
      interestLabel: 'Cosa ti interessa di pi\u00F9?',
      interestOptions: {
        ar: 'Esperienza AR nella natura',
        flora: 'Scoprire flora & fauna',
        routes: 'Sentieri escursionistici',
        stories: 'Leggende e storie',
      },
      visitLabel: 'Quanto spesso visiti la Tscheppaschlucht?',
      visitOptions: {
        never: 'Mai stata/o',
        once: '1\u20132 volte',
        regular: 'Regolarmente',
        local: 'Abito nelle vicinanze',
      },
      deviceLabel: 'Quale dispositivo usi?',
      deviceOptions: {
        iphone: 'iPhone',
        android: 'Android',
      },
      wishLabel: "Cosa vorresti dall'app?",
      wishPlaceholder: 'Le tue idee (opzionale)',
      submit: 'Invia',
      skip: 'Salta',
    },
  },

  navigation: {
    button: 'Navigazione',
    title: 'Mappa',
    close: 'Chiudi mappa',
    centerOnUser: 'Centra sulla mia posizione',
    nearestPoint: 'Punto più vicino',
    distance: (meters) => meters < 1000 ? `${Math.round(meters)} m` : `${(meters / 1000).toFixed(1)} km`,
    learnMore: 'Scopri di più',
    playAudio: 'Riproduci audio',
    locationPermissionDenied: 'Accesso alla posizione negato',
    loadingMap: 'Caricamento mappa…',
    noGps: 'Nessun segnale GPS',

    loadFailed: 'Impossibile caricare la mappa',
    aria: {
      zoomIn: 'Ingrandisci',
      zoomOut: 'Riduci',
      recenter: 'Centra sulla mia posizione',
      followEnable: 'Segui la mia posizione sulla mappa',
      followDisable: 'Interrompi il tracciamento della posizione',
    },
    aux: {
      storyGuideOpen: 'Apri Story Guide',
      storyGuideClose: 'Chiudi Story Guide',
      aiCompanionStart: 'Avvia AI Companion',
      aiCompanionPause: 'Metti in pausa AI Companion',
      photoMap: 'Mostra mappa foto',
      vectorMode: 'Modalità vettoriale',
      diaryEnd: 'Termina diario',
    },
    optionsSheet: {
      adventure: 'Avventura',
      performance: 'Prestazioni',
      map: 'Mappa',
      narrator: 'Narratore',
      voiceComing: 'Voce in arrivo',
    },
    poiCard: {
      audioBtn: 'Audio',
      audioStop: 'Stop',
      moreBtn: 'Altro →',
      endBtn: 'Fine',
      metersAway: 'm di distanza',
      fromStart: 'dalla partenza',
      away: 'di distanza',
      sightLabel: 'Punto di interesse',
    },
    // Routen-Karte (Picker) — Auswaehlen/Starten/Details (Alex 25.07.).
    /** Weggabelung: Routenwechsel direkt im Detail des Punktes
     *  (Alex 2026-08-11 — „wenn man da ist, will man vielleicht doch eine
     *  andere Route wandern"). */
    junction: {
      title: 'Da qui',
      hint: 'Qui i sentieri si dividono. Tocca per cambiare percorso.',
      active: 'Percorso attivo',
    },
    routeCard: {
      select: 'Seleziona',
      active: 'Attiva',
      start: 'Avvia percorso',
      details: 'Dettagli',
    },
  },

  // Entdecken-Oberflaeche. NUR Bedienelemente — POI-Titel, Beschreibungen
  // und Kategorien kommen sprachselektiert aus ArTrack/knowledge-api.
  discover: {
    title: 'Scopri',
    close: 'Chiudi',
    back: 'Indietro',
    searchPlaceholder: 'Cerca luoghi, storie, animali …',
    searchLabel: 'Cerca in Scopri',
    categoryFilterLabel: 'Filtra per categoria',
    detailLabel: 'Dettagli del luogo',
    unavailable: 'Questo luogo non è attualmente disponibile.',
    highlights: 'In evidenza',
    nearby: 'Nelle vicinanze',
    allPlaces: 'Tutti i luoghi',
    categories: 'Categorie',
    filterAll: 'Tutti',
    unitSpecies: 'specie',
    unitPlaces: 'luoghi',
    heroSubtitle: 'Storie, natura e segreti della gola Tscheppaschlucht.',
    openMap: 'Apri la mappa',
    showAll: 'Mostra tutto',
    showOnMap: 'Sulla mappa',
    readAloud: 'Leggi ad alta voce',
    loading: 'Caricamento dei contenuti …',
    nothingFound: (suche: string) => suche
      ? `Nessun risultato per «${suche}».`
      : `Nessun risultato in questa categoria.`,
    stopReading: 'Interrompi lettura',
  },

  footerNav: {
    profileSignIn: 'Profilo — accedi',
    profile: 'Profilo',
    map: 'Mappa',
    discover: 'Scopri',
    chatBot: 'Dr. Tschauko',
    diary: 'Diario',
    debug: 'Debug',
    route: 'Percorso',
  },

  onboarding: {
    welcome: {
      title: 'Grazie per la registrazione!',
      text: 'TSCHAPP ti avvicina alla natura della Tscheppaschlucht \u2014 con Realt\u00E0 Aumentata, mappe interattive e storie affascinanti. Ecco una breve panoramica.',
    },
    flora: {
      title: 'Flora & Fauna',
      text: 'Scopri oltre 80 specie animali e vegetali autoctone con descrizioni dettagliate, modelli 3D e articoli generati dall\u2019AI. Metti like e commenta ogni specie.',
    },
    stories: {
      title: 'Leggende e Storie',
      text: 'Vivi i miti e le leggende della Tscheppaschlucht come audiolibro interattivo \u2014 narrato dalle nostre mascotte Tschauko e Tschauka, illustrato con arte generata dall\u2019AI.',
    },
    routes: {
      title: 'Percorsi escursionistici',
      text: 'Tre percorsi unici attraversano la gola. Ogni percorso ha le proprie stazioni con esperienze AR, profili altimetrici e viste 3D interattive.',
    },
    next: 'Avanti',
    prev: 'Indietro',
    skip: 'Salta',
    start: 'Iniziamo',
  },

  expedition: {
    title: 'La mia spedizione',
    progress: (found, total) => `${found} di ${total} segreti scoperti`,
    nextSecret: 'Trova il prossimo segreto',
    nextSecretSub: 'Segui il prossimo indizio ed esplora la gola.',
    today: 'Scoperto oggi',
    newFound: 'Appena scoperto',
    nextHint: 'Prossimo indizio',
    myFinds: 'Le mie scoperte',
    secretSlot: 'Segreto',
    emptyRoute: 'Per questo sentiero non ci sono ancora segreti registrati.',
    badges: 'Distintivi',
    badgeTracker: { title: 'Cercatore di tracce', text: 'Trovi indizi che gli altri non vedono.' },
    badgePlants: { title: 'Esperto di piante', text: 'Conosci le piante della gola.' },
    missionTitle: 'La tua missione',
    secretNofM: (n, m) => `Segreto ${n} di ${m}`,
    lookLike: 'Potrebbe apparire così',
    whatYouGet: 'Cosa ottieni',
    rewardFind: { title: 'Nuova scoperta', sub: 'Scopri qualcosa di speciale.' },
    rewardProgress: { title: '+1 progresso', sub: 'La tua spedizione continua a crescere.' },
    rewardSecret: { title: '1 segreto più vicino', sub: 'Un passo più vicino alla soluzione.' },
    rewardFindDone: 'Questa scoperta è stata aggiunta alla tua collezione.',
    rewardSecretDone: 'Segreto risolto',
    lookout: 'Tengo gli occhi aperti',
    foundIt: "L'ho trovato",
    later: 'Più tardi',
    fundTitle: 'Grande scoperta',
    solvedNofM: (n, m) => `Segreto ${n} di ${m} risolto`,
    youFound: (name) => `L'hai trovato: ${name}.`,
    progressLabel: 'Progresso della spedizione',
    intoBook: 'Nel libro delle scoperte',
    learnMore: 'Scopri di più',
  },

  forschung: {
    title: 'Diario di ricerca',
    subtitle: 'Annota e comprendi le tue osservazioni.',
    newObservation: '+ Nuova osservazione',
    statBeobachtungen: 'Osservazioni',
    statArten: 'Specie',
    statEntwuerfe: 'Bozze',
    drafts: 'Bozze',
    myEntries: 'Le mie voci',
    emptyEntries: 'Ancora nessuna osservazione. Ciò che vedi, senti o trovi lungo il cammino trova posto qui.',
    untitled: 'Senza titolo',
    status: { draft: 'Bozza', private: 'Privato', submitted: 'In revisione', published: 'Pubblicato', rejected: 'Non pubblicato', queued: 'In attesa di caricamento', queuedRetry: 'Caricamento in ripetizione' },
    newTitle: 'Nuova osservazione',
    gpsPending: 'Il luogo sarà aggiunto appena il GPS è disponibile.',
    capFoto: 'Foto',
    capMediathek: 'Libreria',
    capAudio: 'Audio',
    capAudioStop: (s) => `${s}s stop`,
    capVideo: 'Video',
    mediaHint: (sec) => `Le foto vengono ridotte automaticamente per il caricamento (HD). Video: al massimo ${sec} secondi.`,
    videoTooLong: (sec, max) => `Il video dura ${sec} secondi — il diario ne consente al massimo ${max}, perché il caricamento riesca anche con segnale debole.`,
    videoTooBig: (mb, max) => `Il video è troppo grande (${mb} MB). Registra al massimo ${max} secondi in HD.`,
    titleLabel: 'Titolo',
    noteLabel: 'Nota',
    notePlaceholder: 'Cosa hai osservato?',
    defaultTitleAt: (ort) => `Osservazione presso ${ort}`,
    defaultTitle: 'Osservazione',
    artLabel: 'Collega una specie (facoltativo)',
    artSearch: 'Cerca il nome della specie …',
    artUnlink: 'Rimuovi collegamento',
    save: 'Salva la voce',
    saveHint: 'Salvato in privato — visibile solo a te. Inviare alla community è un passo separato.',
    back: 'Indietro',
    suggest: 'Proponi per la pubblicazione',
    previewHeading: 'Così apparirà il tuo contributo',
    previewHint: 'La tua voce sarà verificata prima di apparire nella community.',
    submit: 'Invia la voce',
    submitting: 'Invio in corso …',
    keepPrivate: 'Mantieni privato',
    edit: 'Modifica',
    delete: 'Elimina la voce',
    deleteConfirm: 'Eliminare definitivamente la voce?',
    keep: 'Mantieni',
    rejectedInfo: (reason) => `La redazione non ha pubblicato questo contributo${reason ? `: ${reason}` : '.'} La tua voce privata rimane.`,
    submitFailed: (detail) => `Invio non riuscito — la voce resta salvata in privato. (${detail})`,
    queuedInfo: (attempts) => `Inviato — il caricamento partirà appena c'è connessione${attempts ? ` (finora ${attempts} tentativi)` : ''}. Puoi chiudere l'app; riproverà alla prossima apertura.`,
    backToList: 'Torna alla panoramica',
    fallbackOrt: 'Tscheppaschlucht',
    community: 'Dalla gola',
    communitySub: 'La community scopre, condivide e custodisce.',
  },
}
